import React, {Component} from "react";
import '../../../assets/sass/components/progress_bars/circular_progress_bar.scss';

class CircularProgressBar extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    render() {
        // Size of the enclosing square
        const sqSize = this.props.sqSize;
        // SVG centers the stroke width on the radius, subtract out so circle fits in square
        const radius = (this.props.sqSize - this.props.strokeWidth) / 2;
        // Enclose chicle in a circumscribing square
        const viewBox = `0 0 ${sqSize} ${sqSize}`;
        // Arc length at 100% coverage is the circle circumference
        const dashArray = radius * Math.PI * 2;
        // Scale 100% coverage overlay with the actual percent
        const dashOffset = dashArray - dashArray * this.props.percentage / 100;

        //IMPORTANT: Don't try to remove inline css, The library for Exporting HTML to canvas require inline css.
        return (
            <svg xmlns="http://www.w3.org/2000/svg" className="circular-progress-bar" width={this.props.sqSize} height={this.props.sqSize} viewBox={viewBox}>
                <circle className="circle-background" fill="transparent" stroke="(255, 255, 255, 0.28)" cx={this.props.sqSize / 2} cy={this.props.sqSize / 2} r={radius} strokeWidth={`${this.props.strokeWidth}px`}/>
                <circle className="circle-progress" fill="transparent" stroke="white" strokeLinecap="round" strokeLinejoin="round" cx={this.props.sqSize / 2} cy={this.props.sqSize / 2} r={radius} strokeWidth={`${this.props.strokeWidth}px`}
                    // Start progress marker at 12 O'Clock
                        transform={`rotate(-90 ${this.props.sqSize / 2} ${this.props.sqSize / 2})`} style={{strokeDasharray: dashArray, strokeDashoffset: dashOffset}}/>
                <text className="circle-text" fill="white" x="50%" y="50%" dy=".3em" fontWeight="bold" fontSize="3em" fontFamily="Poppins" textAnchor="middle"> {this.props.text} </text>
            </svg>
        );
    }
}

CircularProgressBar.defaultProps = {
    sqSize: 200,
    percentage: 25,
    strokeWidth: 15
};

export default CircularProgressBar;
